<template>
    <div v-if="firstRendered">
        <div class="filter-condition box-shadow-small border-radius">
            <multi-search :fields="multiFields"></multi-search>
        </div>
        <div class="filter-result background-white box-shadow-small border-radius">
            <div class="filter-result-header mt-15 clearfix">
                <el-row type="flex" justify="space-between">
                    <el-col :span="12">
                        <el-button class="hide" type="primary">导出面试评分表</el-button>
                        <el-button @click="multiRemarkEdit(idStr)">批量编辑备注</el-button>
                        <el-dropdown>
                            <el-button icon="el-icon-my-daochu" type="info">导出简历<i class="el-icon-caret-bottom el-icon--right"></i></el-button>
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item @click.native="exportFiles(idStr)">导出已选记录(excel)</el-dropdown-item>
                                <el-dropdown-item @click.native="exportFiles(idStr, undefined, undefined, 'type=HTML')">导出已选记录(html)</el-dropdown-item>
                                <el-dropdown-item @click.native="exportParamsFiles('/entry/exportAllResume.api')">导出所有查询结果(excel)</el-dropdown-item>
                                <el-dropdown-item @click.native="exportParamsFiles('/entry/exportAllResume.api', 'HTML')">导出所有查询结果(html)</el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                        <export-custom-dialog :valid-call-back="customExportValid" :params-call-back="customExportParams"></export-custom-dialog>
                    </el-col>
                    <el-col :span="12">
                        <el-row v-if="lists.length" type="flex" justify="end">
                            <el-button @click="changeStatus(idStr,'pass', null, '入职')" icon="el-icon-my-queding color-success" type="success" :plain="true">入职</el-button>
                            <el-button @click="changeStatus(idStr,'notPass', null, '毁约')" icon="el-icon-my-guanbi color-danger" type="danger" :plain="true">毁约</el-button>
                            <el-button @click="changeStatus(idStr,'back')" icon="el-icon-my-huitui color-info" type="info" :plain="true">回退</el-button>
                        </el-row>
                    </el-col>
                </el-row>
            </div>
            <div v-loading="partialLoading">
                <empty-tip :show="!lists.length"></empty-tip>
                <div class="table-list mt-20">
                    <el-table v-if="lists.length"
                              :data="lists"
                              @selection-change="handleSelectionChange">
                        <el-table-column
                                type="selection"
                                align="center"
                                fixed
                                width="50">
                        </el-table-column>
                        <el-table-column
                                label="姓名"
                                :show-overflow-tooltip="true"
                                align="center"
                                fixed
                                min-width="80">
                            <template slot-scope="scope">
                                <span class="name-txt" @click="toResumeDetail(scope.row)">
                                    {{ scope.row.resumeForm.name }}
                                </span>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="resumeForm.gender"
                                label="性别"
                                :show-overflow-tooltip="true"
                                align="center"
                                min-width="70">
                            <template slot-scope="scope">{{{1: '男', 2: '女'}[scope.row.resumeForm.gender] || '-'}}</template>
                        </el-table-column>
                        <el-table-column
                                label="岗位"
                                :show-overflow-tooltip="true"
                                align="center"
                                min-width="120">
                            <template slot-scope="scope">
                                {{ scope.row.positionForm.name }}
                            </template>
                        </el-table-column>
                        <el-table-column
                                label="招聘部门"
                                :show-overflow-tooltip="true"
                                align="center"
                                min-width="100">
                            <template slot-scope="scope">
                                {{ scope.row.positionForm.deptNames }}
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="resumeForm.mobilePhone"
                                label="手机号"
                                :show-overflow-tooltip="true"
                                align="center"
                                min-width="110">
                        </el-table-column>
                        <el-table-column
                                prop="resumeForm.email"
                                label="邮箱"
                                :show-overflow-tooltip="true"
                                align="center"
                                min-width="110">
                        </el-table-column><el-table-column
                            label="最高学历"
                            align="center"
                            :show-overflow-tooltip="true"
                            min-width="80">
                        <template slot-scope="scope">
                            {{ getSelectMapText('WB_EDU_DEGREE', scope.row.resumeForm.resumeMaxEducation.degree) }}
                        </template>
                    </el-table-column>
                        <el-table-column
                                label="最高学历学校"
                                align="center"
                                :show-overflow-tooltip="true"
                                min-width="100">
                            <template slot-scope="scope">
                                <el-tag type="primary" v-if="scope.row.resumeForm.schoolType ==='1'">985</el-tag>
                                <el-tag type="success" v-else-if="scope.row.resumeForm.schoolType ==='2'">211</el-tag>
                                {{ scope.row.resumeForm.resumeMaxEducation.school }}
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="resumeForm.resumeMaxEducation.major"
                                label="专业"
                                :show-overflow-tooltip="true"
                                align="center"
                                min-width="140">
                        </el-table-column>
                        <el-table-column
                                prop="resumeForm.origin"
                                label="籍贯"
                                :show-overflow-tooltip="true"
                                align="center"
                                min-width="140">
                        </el-table-column>
                        <el-table-column
                                label="简历来源"
                                :show-overflow-tooltip="true"
                                align="center"
                                min-width="90">
                            <template slot-scope="scope">
                                {{ getSelectMapText('WB_RESUME_SOURCE', scope.row.resumeForm.resumeSource)}}
                            </template>
                        </el-table-column>
                        <el-table-column
                                label='当前所在地'
                                :show-overflow-tooltip="true"
                                align="center"
                                min-width="100">
                            <template slot-scope="scope">
                                {{ scope.row.resumeForm.residence || '-' }}
                            </template>
                        </el-table-column>
                        <el-table-column
                                label="应聘城市"
                                :show-overflow-tooltip="true"
                                align="center"
                                min-width="80">
                            <template slot-scope="scope">
                                {{ getSelectMapText('WB_POSITION_CITY', scope.row.resumeForm.expectCityId)}}
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="positionForm.sourceFrom"
                                label="投递渠道"
                                :show-overflow-tooltip="true"
                                align="center"
                                min-width="100">
                            <template slot-scope="scope">
                                {{scope.row.resumeForm && getSelectMapText('WB_ADD_SOURCE',
                                scope.row.resumeForm.addSource)}}
                            </template>
                        </el-table-column>
                        <el-table-column
                                label="投递人"
                                prop="resumeForm.addName"
                                :show-overflow-tooltip="true"
                                align="center"
                                min-width="80">
                        </el-table-column>
                        <el-table-column
                                label="推荐人"
                                :show-overflow-tooltip="true"
                                align="center"
                                min-width="80">
                            <template slot-scope="scope">
                                <span v-if="scope.row.resumeForm.recommenderUser">{{scope.row.resumeForm.recommenderUser.name}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column
                                label="游戏经验"
                                :show-overflow-tooltip="true"
                                align="center"
                                min-width="100">
                            <template slot-scope="scope">
                                {{ scope.row.resumeForm.gameExperience }}
                            </template>
                        </el-table-column>
                        <el-table-column
                                label="简历附件"
                                align="center"
                                min-width="120">
                            <template slot-scope="scope">
                                <attach-view-in-list :attachList="scope.row.resumeForm.resumeAttachList"></attach-view-in-list>
                            </template>
                        </el-table-column>
                        <el-table-column align="center" label="投递时间" :show-overflow-tooltip="true" min-width="100">
                            <template slot-scope="scope">{{dateFormat(scope.row.commitTime)}}</template>
                        </el-table-column>
                        <el-table-column
                                label="状态"
                                :show-overflow-tooltip="true"
                                align="center"
                                min-width="130">
                            <template slot-scope="scope">
                                {{getSelectMapText('WB_FLOW_STATUS', scope.row.status)}}
                            </template>
                        </el-table-column>
                        <el-table-column
                                label="操作"
                                align="center"
                                class-name="no-wrap"
                                min-width="80">
                            <template slot-scope="scope">
                                <el-dropdown @command="handleCommand" :hide-on-click="false">
                                    <span class="el-dropdown-link">入职评估</span>
                                    <el-dropdown-menu slot="dropdown">
                                        <el-dropdown-item :command="`${scope.row.id}/pass//入职`"><i class="el-icon-my-queding color-success mr-10"></i>入职
                                        </el-dropdown-item>
                                        <el-dropdown-item :command="`${scope.row.id}/notPass//毁约`"><i class="el-icon-my-guanbi color-danger mr-10"></i>毁约
                                        </el-dropdown-item>
                                        <el-dropdown-item :command="`${scope.row.id}/back`"><i class="el-icon-my-huitui color-info mr-10"></i>回退
                                        </el-dropdown-item>
                                    </el-dropdown-menu>
                                </el-dropdown>
                            </template>
                        </el-table-column>
                        <el-table-column :show-overflow-tooltip="true" label="备注"
                                         align="center"
                                         min-width="120">
                            <template slot-scope="scope">
                                <remark-edit :id="scope.row.resumeForm.id" v-model="scope.row.resumeForm.remark"></remark-edit>
                            </template>
                        </el-table-column>
                        <el-table-column prop="resumeForm.remark" :show-overflow-tooltip="true" label="最近操作人"
                                         align="center"
                                         min-width="130">
                            <template slot-scope="scope">
                                <div style="font-size: 12px;">
                                    <p>{{scope.row.lastOperateUserInfo ? scope.row.lastOperateUserInfo.name : ''}}</p>
                                    <p>{{scope.row.lastOperateTime && scope.row.lastOperateTime.slice(5)}}</p>
                                </div>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <el-pagination
                        v-if="lists.length"
                        class="text-center mt-20 mb-20"
                        @size-change="pageSizeChange"
                        @current-change="pageIndexChange"
                        :current-page="pagination.pageIndex"
                        :page-size="pagination.pageSize"
                        :page-sizes="[20, 50, 100, 200]"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="pagination.recordCounts">
                </el-pagination>
            </div>
            <multi-remark-edit-dialog ref="multiRemarkEditDialog" @reload="fetchData"></multi-remark-edit-dialog>
        </div>
    </div>
</template>
<script type="text/javascript">
    import QueryListExtend from 'components/queryListExtend'
    import selectMapMixin from 'mixins/selectMapMixin'
    import operationMixin from '../operation/operationMixin'
    import RemarkEdit from '../operation/remarkEditDialog.vue'
    import MultiRemarkEditDialog from '../operation/multiRemarkEditDialog.vue'
    import AttachViewInList from '../operation/attachViewInList.vue'
    import queryListMixin from '../operation/queryListMixin'
    import { dateFormat } from 'modules/tools'
    import MultiSearch from 'views/common/multiSearch'


    export default {
        'extends': QueryListExtend,
        'mixins': [selectMapMixin, operationMixin, queryListMixin],
        components: {
            AttachViewInList, RemarkEdit, MultiSearch, MultiRemarkEditDialog
        },
        data () {
            return {
                fetchUrl: '/entry/list.api',
                multiFields: [{
                    filter: 'WB_RESUME_STATUS_7',
                    label: '简历状态',
                    mode: 'select',
                    data: [],
                    name: 'statusSearch'
                }],
                searchData: {
                    searchWord: null
                }
            }
        },
        methods: {
            multiRemarkEdit(ids) {
                if (this.checkDataValid(ids)) {
                    let $target = this.$refs.multiRemarkEditDialog
                    let rids = this.lists
                        .filter(cv => {
                            return ids.indexOf(cv.id) > -1
                        })
                        .map(cv => {
                            return cv.resumeForm.id
                        })
                        .join(',')
                    $target && $target.show(rids)
                }
            },
            dateFormat (date, format = 'yyyy/MM/dd') {
                return dateFormat(date, format)
            },
            addResume () {
                this.$refs.addResumeDialog.show()
            },
            fetchCallback (res) {
                // this.sourceFromSearchProcess(res)
            },
            recommendResume (item) {
                this.$refs.recommendResumeDialog.show(item)
            },
            toResumeDetail (row) {
                let path = this.getResumeDetailUrl(row.id, row.status)

                let routeData = this.$router.resolve({ path })
                window.open(routeData.href, '_blank')
            }
        }
    }
</script>
<style type="text/css" lang="scss">

</style>



// WEBPACK FOOTER //
// entryList.vue?732b57af